import * as React from 'react'
import { ISettingItem } from '../../types'
import Modal from '../ui/Modal'
import SettingRemoveContent from './SettingRemoveContent'
import SettingRemoveErrorContent from './SettingRemoveErrorContent'

interface ISettingRemoveModalProps {
  setting: ISettingItem
  settingType: string
  onClose: () => void
  onRemove: () => void
  error?: string
}

const SettingRemoveModal = (props: ISettingRemoveModalProps) => {
  return (
    <Modal>
      <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
        <div className='bg-white col-3 p2 relative'>
          {props.error ? (
            <SettingRemoveErrorContent error={props.error} setting={props.setting} onClose={props.onClose} />
          ) : (
            <SettingRemoveContent {...props} />
          )}
        </div>
      </div>
    </Modal>
  )
}

export default SettingRemoveModal



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingRemoveModal.tsx